import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import VuePageTransition from "vue-page-transition";
import Helpers from "./commons/Helpers";
import Constants from "./commons/Constants";
import VueNativeNotification from "vue-native-notification";
import Swal from "sweetalert2";
import { userStore } from "./store/userStore.js";

window.jQuery = jQuery;
window.logFun = () => {
  console.log(`${this.name}(${this.arguments.join(", ")})`);
};
window.Swal = Swal;

Vue.use(VueNativeNotification, {
  requestOnNotify: true,
});
Vue.use({
  install() {
    Vue.prototype.$helpers = Helpers;
  },
});
Vue.use({
  install() {
    Vue.prototype.$constants = Constants;
  },
});
Vue.use({
  install() {
    Vue.prototype.$userIsAdmin = () => {
      return userStore.getters.getRole === Constants.userRoles.ADMIN;
    };
  },
});

Vue.filter("money", function (value) {
  return Helpers.asMoney(value);
});
Vue.filter("number", function (value) {
  return Helpers.asNumber(value);
});

Vue.use(VuePageTransition);

Vue.config.productionTip = false;

new Vue({
  store: userStore,
  router,
  render: (h) => h(App),
}).$mount("#app");
